<template>
  <div>
    <div v-if="notificationDetail.length === 0" :class="$style.noNotification">
      <p :class="$style.noNotificationText">No new notification</p>
    </div>
    <div v-if="notificationDetail.length > 0">
      <div
        :class="$style.userInfo"
        :key="index"
        v-for="(info, index) in nonViewedNotification"
      >
        <div
          v-if="
            info.type === 'ADD_NEW_PROJECT_OWNER' &&
            !info.isViewed &&
            info.email !== info.projectOwnerEmail &&
            !info.isReclaimProject
          "
          :class="$style.navigateNotification"
        >
          <div @click="navigateToNotifications()">
            <p :class="$style.userInfoDateTime">
              {{ info.datetime }}
            </p>
            <p :class="$style.userInfoPrimary">
              Project Administration Request
            </p>
            <br />
            <p :class="$style.userInfoTertiary">
              {{ info.notificationSenderName }} requested for you to be the
              project administrator in {{ info.projectName }}.
            </p>
            <br />
          </div>
          <button
            :class="$style.acceptButton"
            @click="handleNotificationRespond(info, true, false)"
          >
            Accept
          </button>
          <button
            :class="$style.declineButtton"
            @click="handleNotificationRespond(info, false, false)"
          >
            Decline
          </button>
        </div>
        <div
          v-if="
            info.type === 'ADD_NEW_PROJECT_OWNER' &&
            !info.isViewed &&
            info.email === info.projectOwnerEmail
          "
          :class="$style.navigateNotification"
        >
          <div @click="navigateToNotifications()">
            <p :class="$style.userInfoDateTime">
              {{ info.datetime }}
            </p>
            <p :class="$style.userInfoPrimary">
              Project Administration Change Request
            </p>
            <br />
            <p :class="$style.userInfoTertiary">
              {{ info.notificationSenderName }} requested to be the project
              administrator for {{ info.projectName }}. If you accept this
              request,
              {{ getParticipantRole(info.payload.participantRole) }}
            </p>
          </div>
          <button
            :class="$style.acceptButton"
            @click="handleNotificationRespond(info, true, true)"
          >
            Accept
          </button>
          <button
            :class="$style.declineButtton"
            @click="handleNotificationRespond(info, false, true)"
          >
            Decline
          </button>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_ACCEPT_FORMER_PROJECT_OWNER' &&
            !info.payload.systemAdminId &&
            info.status === 'accept' &&
            !info.isReclaimProject
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">
            Project Administration Request Accepted
          </p>
          <br />
          <p :class="$style.userInfoTertiary">
            {{ info.notificationSenderName }} accepted your request to be the
            project administrator in {{ info.projectName }}.
          </p>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_ACCEPT_FORMER_PROJECT_OWNER' &&
            info.payload.systemAdminId &&
            info.status === 'accept'
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">Project Administrator Changed</p>
          <br />
          <p :class="$style.userInfoTertiary">
            Project administrator for {{ info.projectName }} has been changed to
            {{ info.notificationSenderName }}.
          </p>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_ACCEPT_PROJECT_OWNER' &&
            !info.isActionable &&
            info.status === 'accept' &&
            !info.isReclaimProject
          "
          :class="$style.navigateNotification"
        >
          <div @click="handleNavigateNotifications()">
            <p :class="$style.userInfoDateTime">
              {{ info.datetime }}
            </p>
            <p :class="$style.userInfoPrimary">
              You Are Now Project Administrator
            </p>
            <br />
            <p :class="$style.userInfoTertiary">
              You are now the project administrator for
              {{ info.projectName }}.
            </p>
          </div>
          <div
            :class="$style.viewProjectLinkStyle"
            @click="handleNavigateSingleNotification(info)"
          >
            View Project
          </div>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_ACCEPT_RECLAIM_PROJECT' &&
            !info.payload.systemAdminId &&
            info.status === 'accept' &&
            info.isReclaimProject
          "
          :class="$style.navigateNotification"
        >
          <div @click="handleNavigateNotifications()">
            <p :class="$style.userInfoDateTime">
              {{ info.datetime }}
            </p>
            <p :class="$style.userInfoPrimary">
              Your Project Administration Change Request Has Been Accepted
            </p>
            <br />
            <p :class="$style.userInfoTertiary">
              You are now the project administrator for {{ info.projectName }}.
            </p>
          </div>
          <div
            :class="$style.viewProjectLinkStyle"
            @click="handleNavigateSingleNotification(info)"
          >
            View Project
          </div>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_DECLINE_PROJECT_OWNER' &&
            info.status === 'decline' &&
            !info.isReclaimProject
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">
            Project Administration Request Declined
          </p>
          <br />
          <p :class="$style.userInfoTertiary">
            {{ info.notificationSenderName }} declined your request to be the
            project administrator in {{ info.projectName }}.
          </p>
          <router-link
            :class="$style.descriptionLinkStyle"
            :to="`/notification`"
          >
            View
          </router-link>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_DECLINE_RECLAIM_PROJECT' &&
            !info.payload.systemAdminId &&
            info.status === 'decline' &&
            info.isReclaimProject
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">
            Your Project Administration Change Request Has Been Declined
          </p>
          <br />
          <p :class="$style.userInfoTertiary">
            {{ info.notificationSenderName }} will remain as the project
            administrator for {{ info.projectName }}.
          </p>
          <router-link
            :class="$style.descriptionLinkStyle"
            :to="`/notification`"
          >
            View
          </router-link>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_CANCEL_PROJECT_OWNER' &&
            info.status === 'cancel' &&
            !info.isReclaimProject
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">
            Project Administration Request Is Cancelled
          </p>
          <br />
          <p :class="$style.userInfoTertiary">
            {{ info.notificationSenderName }} has cancelled the project
            administrator request for {{ info.projectName }}.
          </p>
        </div>
        <div
          v-if="
            info.type === 'UPDATE_CANCEL_RECLAIM_PROJECT' &&
            info.status === 'cancel' &&
            info.isReclaimProject
          "
          :class="$style.navigateNotification"
          @click="handleNavigateNotifications()"
        >
          <p :class="$style.userInfoDateTime">
            {{ info.datetime }}
          </p>
          <p :class="$style.userInfoPrimary">
            Project Administration Change Request Is Cancelled
          </p>
          <br />
          <p :class="$style.userInfoTertiary">
            {{ info.notificationSenderName }} has cancelled the project
            administrator change request for {{ info.projectName }}.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { get as _get, cloneDeep as _cloneDeep } from 'lodash';
import { State, Action } from 'vuex-class';
import { RootState } from '../../../store/store';
import {
  isDifferent,
  isTruthy,
  isDifferentDeep,
} from '../../../jbi-shared/util/watcher.vue-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import { useUserEmail } from '../../../utils/user.util';
import { DATE_FORMAT } from '../../../utils/date.util';
import dayjs from 'dayjs';
import { UpdateProjectOwnerRequestPayload } from '../../../store/modules/projects/types/projects.types';
import {
  UpdateViewedSingleNotificationPayload,
  UpdateNewNotificationPayload,
} from '../../../store/modules/notification/types/notification.types';
import ProjectOwnerRejectForm from './ProjectOwnerRejectForm.vue';

@Component({
  components: {
    ProjectOwnerRejectForm,
  },
})
export default class ProjectOwnerRequestNotification extends Vue {
  @Prop() public notificationInfo!: any;
  @Prop() public notificationIds!: number[];

  public isProjectOwner: boolean = false;
  public projectUserEmail: any = [];
  public projectTitle: string = '';
  public requestStatus: boolean = false;
  public isReclaimProject: boolean = false;

  @Action('projects/updateProjectOwnerRequest')
  public updateProjectOwnerRequest!: (
    payload: UpdateProjectOwnerRequestPayload,
  ) => void;

  @State((state: RootState) => state.projects.projectOwnerRequestPayload)
  public userNotificationAction!: any;

  @Action('notifications/updateViewedNotification')
  public updateViewedNotification!: (
    payload: UpdateNewNotificationPayload,
  ) => void;

  @Action('notifications/updateViewedSingleNotification')
  public updateViewedSingleNotification!: (
    payload: UpdateViewedSingleNotificationPayload,
  ) => void;

  @State((state: RootState) => state.notifications.userViewedNotifications)
  public userViewedNotifications!: any;

  @State((state: RootState) => state.notifications.userViewedSingleNotification)
  public userViewedSingleNotification!: any;

  public notificationDetail: any = [];

  public mounted() {
    this.notificationDetail = _cloneDeep(this.notificationInfo);
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }

  get nonViewedNotification() {
    const notificationDetail = this.notificationDetail.filter(
      (data: any) => !data.isViewed,
    );
    if (Array.isArray(notificationDetail)) {
      return notificationDetail.slice(0, 3).map((item) => {
        if (!item.isViewed) {
          const today = dayjs().format(DATE_FORMAT);
          const yesterday = dayjs().add(-1, 'day').format(DATE_FORMAT);
          const dataUpdatedAt = dayjs(new Date(item.createdAt)).format(
            DATE_FORMAT,
          );

          let dateToDisplay;
          if (dataUpdatedAt === today) {
            dateToDisplay = 'Today';
          } else if (dataUpdatedAt === yesterday) {
            dateToDisplay = 'Yesterday';
          } else {
            dateToDisplay = dataUpdatedAt;
          }

          this.isProjectOwner =
            this.userEmail === item.projectOwnerEmail ? true : false;
          return {
            ...item,
            isProjectOwner: this.isProjectOwner,
            datetime: dateToDisplay,
          };
        }
      });
    }
    return [];
  }

  public handleNotificationRespond(
    info: any,
    isRequestAccepted: boolean,
    isReclaimProject: boolean,
  ) {
    if (!isRequestAccepted) {
      this.$buefy.modal.open({
        parent: this,
        props: {
          notificationSenderName: info.notificationSenderName,
          projectName: info.projectName,
          isReclaimProject,
        },
        events: {
          confirm: async (newValue: any) => {
            this.updateNotificationRespond(
              info,
              false,
              newValue,
              isReclaimProject,
            );
          },
        },
        component: ProjectOwnerRejectForm,
        hasModalCard: true,
      });
    } else {
      this.updateNotificationRespond(info, true, null, isReclaimProject);
    }
  }

  public updateNotificationRespond(
    info: any,
    notificationStatus: boolean,
    notificationReason: string | null,
    isReclaimProject: boolean,
  ) {
    this.projectTitle = info.projectName;
    this.requestStatus = notificationStatus;
    this.isReclaimProject = isReclaimProject;
    const userRespondInfo = {
      token: info.token,
      email: info.email,
      originatorProjectEmail: info.originatorProjectEmail,
      projectId: info.projectId,
      isRequestAccepted: notificationStatus,
      reason: notificationReason,
      isReclaimProject,
    };
    this.updateProjectOwnerRequest(userRespondInfo);
  }

  @Watch('userNotificationAction')
  @isTruthy
  public watchUserNotificationAction(newValue: any) {
    let toastMessage = '';
    if (this.$route.path !== '/notification') {
      if (this.requestStatus) {
        if (this.isReclaimProject) {
          toastMessage = `You have accepted the project administration change request`;
        } else {
          toastMessage = `You are now the project administrator in ‘${this.projectTitle}'.`;
        }
      } else {
        toastMessage = 'Project administration request successfully declined.';
      }
      Toast.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: toastMessage,
      });
    }
    this.$emit('updateNotificationBell');
  }

  public handleNavigateNotifications() {
    this.updateViewedNotification({
      notificationIds: this.notificationIds,
    });
  }

  public handleNavigateSingleNotification(info: any) {
    this.updateViewedSingleNotification({
      notificationId: info.id,
    });
  }

  public getParticipantRole(item: any) {
    if (item === 'None') {
      return 'you will no longer be a participant in this project.';
    }
    return `your new role in this project will be ${item}.`;
  }

  public navigateToNotifications() {
    this.$router.replace('/notification');
  }

  @Watch('userViewedNotifications')
  @isTruthy
  public watchUserViewedNotification(newValue: any) {
    if (this.$route.path !== '/notification') {
      this.$router.replace('/notification');
    }
  }

  @Watch('userViewedSingleNotification')
  @isTruthy
  public watchUserViewedSingleNotification(newValue: any) {
    if (this.$route.path !== '/notification') {
      this.$router.replace(`/projects/${newValue.project.id}#dashboard`);
    }
  }
}
</script>

<style lang="scss" module>
.container {
  :global {
    .dropdown-content {
      padding: 0px;
      width: 250%;
    }

    .dropdown-item {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}

.navLinkSection {
  border-top: 1px solid $grey-border;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0px;
  padding-right: 30px;
}

.navDropdownTrigger {
  &#{&}#{&}#{&}#{&} {
    font-size: 20px;
    text-align: center;
    border-radius: 100%;
    width: 42px;
    height: 42px;
  }
}

.userInfo {
  border-bottom: 1px solid $grey-border;
  padding: 10px 10px 10px;

  .userInfoPrimary {
    color: $grey;
    font-size: 14px;
    font-weight: 700;
    white-space: pre-line;
    overflow: visible;
    text-overflow: ellipsis;
    text-align: left;
  }

  .userInfoDateTime {
    color: $grey;
    font-size: 12px;
    font-weight: 400;
    overflow: auto;
    text-align: justify;
    padding-bottom: 3px;
  }

  .userInfoTertiary {
    color: #444f51;
    font-size: 12px;
    font-weight: 500;
    overflow: auto;
    text-align: justify;
    padding-bottom: 10px;
  }

  &:hover {
    background-color: #eff7ff;
    cursor: pointer;
  }
}
.acceptButton {
  border-radius: 290486px;
  padding-left: calc(1em + 0.25em);
  padding-right: calc(1em + 0.25em);
  border-color: transparent;
  background-color: #00205b;
  color: #fff;
  display: inline-block;
  cursor: pointer;
  margin-right: 5px;
}
.declineButtton {
  border-radius: 290486px;
  padding-left: calc(1em + 0.25em);
  padding-right: calc(1em + 0.25em);
  border-color: transparent;
  background-color: transparent;
  color: #ff465d;
  display: inline-block;
  cursor: pointer;
}
.notificationButton {
  border-color: transparent;
  background-color: white;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: calc(0.5em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(0.5em - 1px);
  text-align: center;
  white-space: nowrap;
}
.noNotification {
  height: 100px;
  width: 300px;
  padding-top: 40px;
  border-bottom: 1px solid $grey-border;

  .noNotificationText {
    color: #9f9f9f;
    font-size: 12px;
    font-weight: 400;
    overflow: auto;
    text-align: center;
  }
}
.descriptionLinkStyle {
  font-weight: bold;
  color: #00205b;
  font-size: 12px;
  padding-top: 40px;
}
.descriptionLinkStyle:hover {
  text-decoration: underline;
}
.viewProjectLinkStyle {
  font-weight: bold;
  color: #00205b;
  font-size: 12px;
}
.viewProjectLinkStyle:hover {
  text-decoration: underline;
}
.navigateNotification {
  cursor: pointer;
  text-align: left;
}
</style>
